/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const progress_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1m3 6.5-6 9M11 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    />
  </svg>
)
export default progress_medium
